// @flow

import { noop } from 'lodash/fp';
import {
    getDeviceName,
    getDeviceType,
    getDeviceZoneId,
    getHueBridge,
    getIsHueDevice,
    getDeviceManufacturer
} from '~/core/state/devices/selectors';
import { removeDevice, removeZone } from '~/core/state/devices/actions';
import { getProductsByZone } from '~/core/state/products/selectors';
import { categories } from './constants';
import messages from '~/core/i18n/components/widgets/remove-device/intl';

type StateProps = {
    deviceId: string,
    deviceName: ?string,
    hueBridgeId: ?string,
    manufacturer: ?string,
    type: string,
    deviceCategory: ?string,
    zoneId: ?string,
    zoneProducts: string
};

type DispatchProps = {
    removeDevice: noop,
    removeZone: noop
};

type InputProps = {
    deviceId: string
};

export const mapCategoryToHeading = (category: string) => {
    const headingMap = new Map([
        [category === categories.HUE, messages.removeHueTitle],
        [category === categories.ZONE, messages.removeZoneTitle],
        [category === categories.DEVICE, messages.removeDeviceTitle]
    ]);
    return headingMap.get(true);
};

const mapCategoryToRemoveFunction = (category, deviceHandler, zoneHandler, hueHandler) => {
    const functionMap = new Map([
        [category === categories.HUE, hueHandler],
        [category === categories.ZONE, zoneHandler],
        [category === categories.DEVICE, deviceHandler]
    ]);
    return functionMap.get(true);
};

const getCategory = (isHueDevice, zoneId) => {
    const categoryMap = new Map([[true, categories.DEVICE], [isHueDevice, categories.HUE], [zoneId, categories.ZONE]]);
    return categoryMap.get(true);
};

export const mapStateToProps = (state: *, { deviceId }: InputProps): StateProps => {
    const props = { id: deviceId };

    const zoneId = getDeviceZoneId(state, props);
    const zoneProducts = getProductsByZone(state, { id: deviceId, zone: zoneId });
    const isHueDevice = getIsHueDevice(state, props);
    const hueBridge = getHueBridge(state);

    // $FlowFixMe
    return {
        deviceId,
        deviceName: getDeviceName(state, props).getOrElse(''),
        hueBridgeId: hueBridge && hueBridge.id,
        manufacturer: getDeviceManufacturer(state, props),
        type: getDeviceType(state, props),
        deviceCategory: getCategory(isHueDevice, zoneId),
        zoneId,
        zoneProducts
    };
};

export const mapDispatchToProps: DispatchProps = {
    removeDevice,
    removeZone
};

export const mergeProps = (stateProps: StateProps, dispatchProps: DispatchProps, ownProps: *) => {
    const { deviceId, hueBridgeId, deviceCategory, zoneId, zoneProducts, deviceName, type }: StateProps = stateProps;
    const { removeDevice, removeZone }: DispatchProps = dispatchProps;

    const deviceHandler = () => removeDevice({ id: deviceId });
    const zoneHandler = () => removeZone({ id: zoneId, zoneProducts });
    const hueHandler = () => removeDevice({ id: hueBridgeId });

    return {
        ...ownProps,
        deviceCategory,
        deviceName,
        remove: mapCategoryToRemoveFunction(deviceCategory, deviceHandler, zoneHandler, hueHandler),
        type
    };
};



// WEBPACK FOOTER //
// ./src/core/components/widgets/remove-device/index.js